import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { CsIconModule } from '@components/icon';
import { LanguageChangeModule } from '@shared/bottom-sheet-layouts/language-change/language-change.module';
import { ChangeLanguagePageComponent } from './change-language.component';

@NgModule({
  imports: [
    CommonModule,
    MatBottomSheetModule,
    CsIconModule,
    LanguageChangeModule,
    ChangeLanguagePageComponent,
  ],
  exports: [ChangeLanguagePageComponent],
})
export class ChangeLanguageModule {}
